import React  from 'react';
import { useAppContext } from 'context/AppContext';
import { makeStyles } from 'styles/util';
import PropTypes from 'prop-types';
import strings from 'localization/strings';
import { formatShortDate } from 'helpers/DateHelper';
import { encodePathComponent } from 'helpers/StringHelper';
import routes from 'routes';

import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Text from 'common/Text';
import MarginBox from 'common/MarginBox';
import { Link } from 'react-router-dom';

const useStyles = makeStyles(() => ({
    leadParagraph: {
        '& img': {
            width: '100%'
        }
    }
}));

const NewsArticleListItem = ({ newsArticle }) => {
    const classes = useStyles();
    const { appContext } = useAppContext();

    return (
        <Box>
            <Typography variant="h2" gutterBottom>
                {newsArticle.title}
            </Typography>

            <Typography variant="body2" gutterBottom>
                {strings.formatString(strings.publishedAtX, formatShortDate(newsArticle.publicationDate, appContext))}
            </Typography>

            <MarginBox bottom={2}>
                <Text html={newsArticle.leadParagraph} className={classes.leadParagraph}/>
            </MarginBox>

            <Typography variant="body2">
                <Link to={routes.newsArticle.replace(':newsArticleId', newsArticle.id).replace(':title', encodePathComponent(newsArticle.title))}>
                    {strings.readMore}
                </Link>
            </Typography>
        </Box>
    );
};

NewsArticleListItem.propTypes = {
    newsArticle: PropTypes.object.isRequired
};

export default NewsArticleListItem;
